// extracted by mini-css-extract-plugin
export var askAiIcon = "_ot-9";
export var container = "_ot-0";
export var groupSeparator = "_ot-a";
export var highlight = "_ot-4";
export var resultIcon = "_ot-5";
export var resultItem = "_ot-7";
export var resultSubtitle = "_ot-3";
export var resultTitle = "_ot-2";
export var resultsList = "_ot-1";
export var searchGroup = "_ot-6";
export var selected = "_ot-8";